import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { problems } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="border-b border-arena bg-arena/40" data-id="element-108" data-mp="2lu4o5ip4lm78">
      <div className="mx-auto max-w-3xl px-4 py-6 sm:py-9" data-id="element-109" data-mp="30isg7ezrjdsf">
        <SectionHeader id="problema" eyebrow="¿Te suena familiar?" title="Quieres aprender macramé, pero no sabes por dónde empezar." description="Si estás comenzando desde cero, probablemente conozcas alguna de estas situaciones:" data-id="element-110" data-mp="2vpzc8tc4c9he" />
        <ul className="mt-4 grid gap-2 sm:grid-cols-2" data-id="element-111" data-mp="3jg1yutx9kn8m">
          {problems.map(p => <li key={p.title} className="flex gap-2.5 rounded-xl border border-l-4 border-arena border-l-terracota bg-crudo p-3" data-id="element-112" data-mp="3jdpigl75mkxo">
              <span aria-hidden="true" className="text-lg leading-none" data-id="element-113" data-mp="1p2av2b1m8xl3">
                {p.emoji}
              </span>
              <div data-id="element-114" data-mp="1k5anfvp4bmrv">
                <h3 className="text-sm font-extrabold text-marron" data-id="element-115" data-mp="jddgajcd4x0t">{p.title}</h3>
                <p className="mt-0.5 text-[0.8rem] leading-snug text-marron/80 sm:text-sm" data-id="element-116" data-mp="jbafd49o9jhb">{p.desc}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}